import { conversion } from 'country-configuration/currency'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import type { CountryConfiguration } from 'types/countryConfiguration'

export function getCurrencyRangeString(
	{ min, max }: { min: number; max: number },
	country: CountryConfiguration,
	t: (key: string) => string
): string {
	const minCurrency = conversion(min, country)
	const maxCurrency = conversion(max, country)
	return replacePlaceholders(t('product.filters.priceFromTo.text'), {
		1: minCurrency.price,
		2: maxCurrency.price,
	})
}
